<template>
  <div>
    <el-card class="box-card">
      <span slot="header">{{ $t('Tool.MyInfo') }}</span>
      <el-form ref="form" class="personal-form" :model="form" :disabled="!isEdit" label-width="110px">
        <el-form-item :label="$t('Tool.CNName')" prop="chineseName">
          <el-input v-model="form.chineseName" size="small" disabled />
        </el-form-item>
        <el-form-item :label="$t('Tool.ENName')" prop="englishName">
          <el-input v-model="form.englishName" size="small" />
        </el-form-item>
        <el-form-item :label="$t('Tool.Phone')" prop="userPhone">
          <el-input v-model="form.cell" />
        </el-form-item>
        <el-form-item :label="$t('Tool.Tel')" prop="phone">
          <el-input v-model="form.phone" size="small" />
        </el-form-item>
        <el-form-item label="FAX：" prop="fax">
          <el-input v-model="form.fax" size="small" />
        </el-form-item>
        <el-form-item :label="$t('Tool.Email')" prop="email">
          <el-input v-model="form.email" size="small" disabled />
        </el-form-item>
        <el-form-item :label="$t('Tool.QQ')" prop="qq">
          <el-input v-model="form.qq" size="small" />
        </el-form-item>
      </el-form>

      <div class="personal-footer">
        <el-button v-if="!isEdit" type="primary" @click="isEdit=true">{{ $t('Tool.Edit') }}</el-button>
        <el-button v-if="!isEdit" type="danger" @click="modifyPasswordDialogVisible=true">{{ $t('Tool.ChangePsd') }}</el-button>

        <el-button v-if="isEdit" type="primary" @click="saveHandler">{{ $t('Tool.Save') }}</el-button>
        <el-button v-if="isEdit" type="primary" plain @click="cancelEdit">{{ $t('Tool.Cancel') }}</el-button>
        <el-button v-if="isEdit" type="danger" @click="modifyPasswordDialogVisible=true">{{ $t('Tool.ChangePsd') }}</el-button>
      </div>
      <modify-password-dialog :visible.sync="modifyPasswordDialogVisible" />
    </el-card>
    <el-card class="box-card" style="margin-top:15px;">
      <span slot="header">{{ $t('Tool.PersonalEmailSettings') }}</span>
      <el-form ref="form" class="personal-form" :model="emailSettings" label-width="130px">
        <el-form-item :label="$t('Tool.Email')">
          <el-input v-model="emailSettings.authSender" size="small" disabled />
        </el-form-item>
        <el-form-item>
          <line-label slot="label" :label="$t('Tool.EmailPassword')" />
          <el-input v-model="emailSettings.authSenderPwd" type="password" show-password size="small" :disabled="editControl" />
        </el-form-item>
        <el-form-item :label="$t('SystemMaintenance.SenderServer')">
          <el-input v-model="emailSettings.smtpHost" :disabled="editControl" />
        </el-form-item>
        <el-form-item :label="$t('SystemMaintenance.Port')">
          <el-input
            :value="emailSettings.smtpPort===0?'':emailSettings.smtpPort"
            :disabled="editControl"
            @input="onSmtpPortInput"
          />
        </el-form-item>
        <el-form-item :label="$t('Tool.SignatureSetup')" prop="sign">
          <div v-show="editControl" class="mask" />
          <quill-editor
            ref="myQuillEditor"
            v-model="emailSettings.sign"
            :options="editorOption"
            @change="onEditorChange($event)"
          />
        </el-form-item>
        <el-checkbox v-model="signature" style="margin-left:110px;" :true-label="1" :false-label="0">{{ $t('Tool.ToEnableTheSignature') }}</el-checkbox>
        <el-checkbox v-model="emailSettings.smtpSsl" style="margin-left:50px;" :true-label="1" :false-label="0" :disabled="editControl">{{ $t('Tool.UseSsl') }}</el-checkbox>
      </el-form>
      <div class="personal-footer">
        <el-button v-show="editControl" type="primary" @click="emailEditor">{{ $t('Tool.Edit') }}</el-button>
        <el-button v-show="!editControl" type="primary" @click="emailSave">{{ $t('Tool.Save') }}</el-button>
        <el-button v-show="!editControl" type="primary" plain @click="cancelPersonalEditing">{{ $t('Tool.Cancel') }}</el-button>
        <el-button type="primary" @click="sendTest">{{ $t('Tool.SendTest') }}</el-button>
      </div>
    </el-card>

    <el-card class="box-card authorization" style="margin-top:15px;">
      <span slot="header">{{ $t('Message.CurrentPersonalAuthorizationList') }}</span>
      <cargo-ag-grid
        style="height:200px;"
        :grid-options="individual.gridOptions"
        :column-defs="individual.columnDefs"
        :show-side-bar="false"
        :row-data="individual.rowData"
      />
    </el-card>
    <el-card v-show="showUserConfig" class="box-card authorization" style="margin-top:15px;">
      <span slot="header">{{ $t('CargoMsg.Cargo_PushNodeSettings') }}</span>
      <el-form
        label-width="100px"
        label-position="left"
      >
        <el-form-item :label="$t('CargoMsg.Cargo_WarningSwitch')">
          <el-radio-group v-model="dataServiceForm.open" :disabled="!isEditDataService">
            <el-radio :label="1">{{ $t('CargoMsg.Cargo_StartAlert') }}</el-radio>
            <el-radio :label="0">{{ $t('CargoMsg.Cargo_CloseAlert') }}</el-radio>
            <el-radio :label="2">{{ $t('CargoMsg.Cargo_ConfigurationAlert') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_DocumentNotification')">
          <el-radio-group v-model="dataServiceForm.notifyJobType" :disabled="isOtherFieldsDisabled">
            <el-radio style="margin-bottom: 5px" :label="0">{{ $t('CargoMsg.Cargo_NoticeOfEachBill') }}</el-radio>
            <el-radio :label="1">{{ $t('CargoMsg.Cargo_NoNoticeOfTickets') }}</el-radio></el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_WarningConditions')">
          <el-checkbox-group v-model="dataServiceForm.ruleItem" style="width: 405px" :disabled="isOtherFieldsDisabled">
            <el-checkbox v-for="(item, index) in warningTypes" :key="index" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('Message.PortOfDepartureUpdate')">
          <el-checkbox-group v-model="dataServiceForm.ruleItem" style="width: 405px" :disabled="isOtherFieldsDisabled">
            <el-checkbox v-for="(item, index) in portAreaReminder" :key="index" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
            <br>
            <el-checkbox v-for="(item, index) in nodeAlertTypes" :key="index+1" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('Message.DestinationPortUpdate')">
          <el-checkbox-group v-model="dataServiceForm.ruleItem" style="width: 405px" :disabled="isOtherFieldsDisabled">
            <el-checkbox v-for="(item, index) in DestinationPortNodeAlertTypes" :key="index" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ReminderMethod')">
          <el-checkbox v-model="dataServiceForm.email" :true-label="1" :false-label="0" :disabled="isOtherFieldsDisabled">{{ $t('CargoMsg.Cargo_Email2') }}</el-checkbox>
          <el-checkbox v-model="dataServiceForm.weChat" :true-label="1" :false-label="0" :disabled="isOtherFieldsDisabled">{{ $t('CargoMsg.Cargo_Wechat') }}</el-checkbox>
        </el-form-item>
        <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceChart.warmPrompt')" class="warm-prompt-item">
          <div style="width: 380px">
            <span style="color: #999;">{{ $t('CargoMsg.Cargo_DataServiceReminderWarning1') }}</span> <br>
            <span style="color: #999;">{{ $t('CargoMsg.Cargo_DataServiceReminderWarning2') }}</span>
          </div>
        </el-form-item>
      </el-form>
      <div class="personal-footer">
        <el-button v-show="!isEditDataService" type="primary" @click="isEditDataService = true">{{ $t('Tool.Edit') }}</el-button>
        <el-button v-show="isEditDataService" type="primary" @click="saveDataService">{{ $t('Tool.Save') }}</el-button>
        <el-button v-show="isEditDataService" type="primary" plain @click="cancelDataService">{{ $t('Tool.Cancel') }}</el-button>
      </div>
    </el-card>
    <!-- 授权说明弹窗 -->
    <el-dialog
      :visible="authorizationVisible"
      :title="title"
      width="500px"
      :append-to-body="true"
      @close="authorizationVisible = false"
    >
      <div v-html="content">
        <!--        <p style="font-size:14px;">发布者希望联系您</p>-->
        <!--        <p style="font-size:14px;color:#1F75D5;">信息发布者申请您在浏览信息时可以留下您在CargoWare系统中登记的手机号码和邮箱地址。</p>-->
        <!--        <p style="font-size:14px;">以便于信息发布者可以和您及时联系，促成业务合作。</p>-->
        <!--        <p style="font-size:14px;">您稍后也可以在设置与工具的个人信息模块中关闭或开启您的分享信息授权。</p>-->
      </div>
    </el-dialog>
    <!-- 邮件弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="secondaryConfirmation"
      append-to-body
      :close-on-click-modal="false"
      :title="$t('Message.SendTest')"
      width="350px"
    >
      <div style="isplay: flex;align-items: center;justify-content: center;">
        <el-row style="display: flex;align-items: center;">
          <el-col :span="6" style="text-align:right;">{{ $t('Message.SendTo') }}</el-col>
          <el-col :span="18">
            <el-input v-model="sendTestVal" />
          </el-col>
        </el-row>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="againDetermine">{{ $t('Message.Confirm2') }}</el-button>
        <el-button plain @click="confirmAgain">{{ $t('Message.Cancel') }}</el-button>
      </div>
    </el-dialog>
    <we-chat-auth-dialog
      v-show="weChatVisible"
      :visible="weChatVisible"
      :data="openData"
      @close="weChatVisible=false"
      @change="changeWeChatAuth"
    />
  </div>
</template>

<script>
import ModifyPasswordDialog from './modifyPasswordDialog'
import * as userApi from '@/api/user'
import { getLoading } from '@/utils/utilBaseElement'
import { getAuthUserInfo } from '@/api/auth'
import { getToken } from '@/utils/auth'
import { Base64 } from 'js-base64'
import { quillEditor } from 'vue-quill-editor'
import { DocumentManage } from '@/utils/commonUtil'
import { getUserAuthBySessionId, updateUserAuth } from '@/api/auth'
import WeChatAuthDialog from '@/components/Cargo/Common/NavbarMenu/components/SettingAndTools/weChatAuthDialog'
import { Assert } from '@/utils/validate'
import { getWarningRuleList, querySOPConfig } from '@/api/sysManage/baseConfig/warnRuleConfiguration'
import * as commonUtil from '@/utils/commonUtil'

export default {
  name: 'PersonalInfoForm',
  components: { WeChatAuthDialog, ModifyPasswordDialog, quillEditor },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      showUserConfig: false,
      dataServiceForm: {
        open: 2,
        notifyJobType: 0,
        ruleItem: [],
        alertTypes: [],
        email: 0,
        weChat: 0
      },
      // 授权说明弹窗提示内容
      title: '',
      content: '',
      authorizationVisible: false,
      documentManage: new DocumentManage(),
      individual: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          pagination: false
        },
        columnDefs: [
          {
            headerName: this.$t('Message.AuthorizationItem'),
            field: 'authItem',
            suppressMenu: true,
            width: 140
          }, {
            headerName: this.$t('Message.AuthorizationStatus'),
            field: 'status',
            suppressMenu: true,
            width: 80,
            cellRenderer: params => {
              if (!params.data.state) {
                return this.$t('Message.NotSet')
              }
              return params.data.state === 1 ? this.$t('Message.Open') : this.$t('Message.Close')
            }
          },
          {
            headerName: this.$t('Message.StatusChangeTime'),
            field: 'dateModified',
            suppressMenu: true,
            width: 140
            // cellRenderer: params => {
            //   return DateUtils.customFormat(params.value, DateUtils.STANDARD_MINUTE_TIME)
            // }
          },
          {
            headerName: this.$t('Message.Operation'),
            field: 'operation',
            suppressMenu: true,
            width: 140,
            cellRenderer: params => {
              const operation = this.documentManage.getPath('operation')
              const explain = this.documentManage.getPath('explain')
              const rowData = JSON.stringify(params.data).replace(/"/g, '&quot;')
              return `<div>
                        <a onclick="${operation}(${rowData})" style="color:#1F75D5;">${params.data.state === 1 ? this.$t('Message.Close') : this.$t('Message.Open')}</a>
                        <a onclick="${explain}(${rowData})" style="color:#1F75D5;">${this.$t('Message.AuthorizationItemDescription')}</a>
                      </div>`
            }
          }
        ],
        rowData: []
      },
      form: {
        chineseName: '',
        englishName: '',
        cell: '',
        phone: '',
        fax: '',
        email: '',
        qq: ''
      },
      editControl: true,
      secondaryConfirmation: false,
      sendTestVal: '',
      emailSettings: {
        authSender: '',
        authSenderPwd: '',
        smtpHost: '',
        smtpPort: 0,
        sign: '',
        branchId: '',
        userId: '',
        enableSign: '',
        smtpSsl: 0,
        enable: 1
      },
      signature: 0,
      editorOption: {
        modules: {
          toolbar: {
            container: [
              /* eslint-disable */
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
              // ["blockquote", "code-block"], // 引用  代码块
              // [{ header: 1 }, { header: 2 }], // 1、2 级标题
              // [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
              // [{ script: "sub" }, { script: "super" }], // 上标/下标
              // [{ indent: "-1" }, { indent: "+1" }], // 缩进
              // [{'direction': 'rtl'}],                         // 文本方向
              [{ size: ["small", false, "large", "huge"] }], // 字体大小
              // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              // [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              // [{ font: [] }], // 字体种类
              // [{ align: [] }], // 对齐方式
              ["clean"], // 清除文本格式
              ["link", "image"], // 链接、图片
            ]
          }
        },
        placeholder: '请在这里添加产品描述', //提示
        readyOnly: false, //是否只读
        theme: 'snow', //主题 snow/bubble
        syntax: true, //语法检测
      },
      isEdit: false,
      modifyPasswordDialogVisible: false,
      weChatVisible: false,
      openData: null,
      isEditDataService: false
    }
  },
  computed: {
    branchId() {
      return this.$store.state.settings.tempBranchId > 0 ? this.$store.state.settings.tempBranchId : this.$store.getters.currentOfficeId
    },
    // 判断除了open以外的其他字段是否应该被禁用
    isOtherFieldsDisabled() {
      return !this.isEditDataService || this.dataServiceForm.open === 2
    },
    portAreaReminder() {
      if (!this.dataServiceForm.alertTypes || this.dataServiceForm.alertTypes.length === 0) {
        return []
      }
      return this.dataServiceForm.alertTypes.filter(item => [5].indexOf(item.code) > -1)
    },
    nodeAlertTypes() {
      if (!this.dataServiceForm.alertTypes || this.dataServiceForm.alertTypes.length === 0) {
        return []
      }
      return this.dataServiceForm.alertTypes.filter(item => [21, 22, 23, 24, 25, 26, 27, 28, 29].indexOf(item.code) > -1)
    },
    DestinationPortNodeAlertTypes() {
      if (!this.dataServiceForm.alertTypes || this.dataServiceForm.alertTypes.length === 0) {
        return []
      }
      return this.dataServiceForm.alertTypes.filter(item => [14, 15, 16, 17].indexOf(item.code) > -1)
    },
    warningTypes() {
      if (!this.dataServiceForm.alertTypes || this.dataServiceForm.alertTypes.length === 0) {
        return []
      }
      return this.dataServiceForm.alertTypes.filter(item => [5, 6, 7, 11, 14, 15, 16, 17, 21, 22, 23, 24, 25, 26, 27, 28, 29].indexOf(item.code) === -1)
    }
  },
  watch: {
    '$store.state.permission.carousel'(val) {
      console.log(val)
      this.getAuthorizationData()
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('operation', function(value) {
      context.openOrClose(value)
    })
    this.documentManage.set('explain', function(value) {
      context.explain(value)
    })
  },
  mounted() {
    this.initDataService()
    this.setInitUserInfo()
    this.getAuthorizationData()
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async initDataService() {
      await this.getDataServiceConfig()
      if (this.showUserConfig) {
        await this.getDataServiceUserConfig()
        await this.getWarningRule()
      }
    },
    // 获取数据服务总配置
    async getDataServiceConfig() {
      const params = {
        type: 2,
        lob: 'SE',
        open: 1
      }
      await getWarningRuleList(params).then((res) => {
        const data = res.data.list
        if (data && data.length > 0) {
          this.showUserConfig = data[0].userConfigOpen === 1
        }
      })
    } ,
    // 获取数据服务配置
    async getDataServiceUserConfig() {
      await querySOPConfig({}).then(async(res) => {
        const warnRules = res.data.warnDateEnum
        this.dataServiceForm.alertTypes = warnRules.filter(item => item.warnType === 2)
      })
    },
    // 获取本人数据服务推送配置
    async getWarningRule() {
      const warningRule = await userApi.getUserWarning().then(res=>res.data)
      if (warningRule) {
        this.dataServiceForm.open = (!warningRule.open && warningRule.open !== 0) ? 2 : warningRule.open
        this.dataServiceForm.ruleItem = commonUtil.splitToNumberArray(warningRule.ruleItem, ',')
        this.dataServiceForm.notifyJobType = warningRule.notifyJobType || 0
        this.dataServiceForm.email = warningRule.email
        this.dataServiceForm.weChat = warningRule.weChat
        console.log('this.dataServiceForm.weChat', this.dataServiceForm)
      } else {
        this.dataServiceForm = {
          open: 2,
          notifyJobType: 0,
          ruleItem: [],
          email: 0,
          weChat: 0,
          alertTypes: this.dataServiceForm.alertTypes
        }
      }
    },
    // 操作开启或者关闭
    openOrClose(rowData) {
      // 如果选择的不是微信，或未点击关闭状态时
      if (rowData.authItem !== '微信消息推送' || rowData.state === 1) {
        this.updataAuthorizationData(rowData)
        return
      }
      // 如果开启的是微信推送通知时
      this.weChatVisible = true
      this.openData = rowData
    },
    // 获取通告板个人信息权限
    async getAuthorizationData() {
      const res = await getUserAuthBySessionId()
      if (res.ok && res.data) {
        this.individual.rowData = res.data
      }
    },
    // 更新通告板个人信息权限
    async updataAuthorizationData(rowData) {
      const data = {
        authItem: rowData.authItem,
        state: rowData.state === 1 ? 2 : 1
      }
      const res = await updateUserAuth(data)
      // 设置跑马灯权限状态
      if (res.ok) {
        if (rowData.authItem === '跑马灯开关') {
          await this.$store.dispatch('permission/setCarousel', data.state)
        } else {
          await this.getAuthorizationData()
        }
      }
    },
    // 打开授权说明弹窗
    explain(row) {
      this.title = row.title
      this.content = row.content
      this.authorizationVisible = true
    },
    // 获取个人邮箱信息
    async getPersonalEmail() {
      const data = {
        mailType: '2',
        branchId: this.branchId
      }
      const personalInfo = await userApi.getPersonalEmail(data).then(resp => resp.data[0])
      if(personalInfo){
        this.emailSettings = {...personalInfo}
        if(this.emailSettings.authSenderPwd){
          this.emailSettings.authSenderPwd = Base64.decode(this.emailSettings.authSenderPwd)
        }
      } else {
        this.emailSettings = {
          authSender: '',
          authSenderPwd: '',
          smtpHost: '',
          smtpPort: 0,
          sign: '',
          branchId: '',
          userId: '',
          enableSign: '',
          enable: 1 // 默认启用个人设置邮箱
        }
      }
      if(!this.emailSettings.authSender){
        this.emailSettings.authSender = this.$store.getters.userInfo.email
      }
    },
    // 邮箱保存
    async emailSave() {
      await Assert.isNumber(this.emailSettings.smtpPort, this.$t('SystemMaintenance.PersonalNumberMustBeNumber'))
      const data = [
        {
          ...this.emailSettings,
          authSenderPwd: Base64.encode(this.emailSettings.authSenderPwd),
          mailType:'2',
          branchId: this.branchId,
          enableSign: this.signature
        }
      ]
      const saveInfo = await userApi.updatePersonalEmail(data).then(res=>res.data)
      if(saveInfo){
        this.editControl = true;
        this.$confirm(this.$t('Tool.SaveSucceed'))
        this.getPersonalEmail()
      }
    },
    // 值发生变化
    onEditorChange(editor) {
      this.emailSettings.sign = editor.html
    },
    // 邮箱编辑
    emailEditor() {
      this.editControl = false;
    },
    //取消个人邮箱编辑
    cancelPersonalEditing(){
      this.editControl = true;
    },
    // 发送测试
    sendTest() {
      if(!this.emailSettings.authSenderPwd){
        this.$message.warning('请填写邮箱密码/授权码！')
        return false;
      }
      this.sendTestVal = '';
      this.secondaryConfirmation = true;
    },
    //取消发送
    confirmAgain(){
      this.secondaryConfirmation = false;
    },
    // 确定发送
    async againDetermine(){
      const self = this;
      if(!self.sendTestVal){
        self.$message.warning(this.$t('Message.PleaseFillInRecipientEmail'))
        return false;
      }
      const loading = getLoading()
      const data = {
        smtpHost:self.emailSettings.smtpHost,
        smtpPort:self.emailSettings.smtpPort,
        authSender:self.emailSettings.authSender,
        senderMail:self.emailSettings.authSender,
        authSenderPwd: Base64.encode(self.emailSettings.authSenderPwd),
        enableSign:self.signature,
        sign:self.emailSettings.sign,
        toEmailAddress:self.sendTestVal,
        themeTemplate: this.$t('Message.EmailSettingsTestEmail'),
      }
      const receiveInfo = await userApi.personalSendTest(data).then(res=>res.ok).finally(() => {
        loading.close();
      })
      if(receiveInfo){
        self.$message.success(this.$t('Message.SendSuccessfully'))
        self.secondaryConfirmation = false;
        loading.close();
      }
    },
    cancelEdit() {
      this.$confirm(this.$t('Tool.CancelChange'), this.$t('CargoMsg.Cargo_ConfirmR')).then(() => {
        this.setInitUserInfo()
        this.isEdit = false

      })
    },
    async setInitUserInfo() {
      const userInfo = await userApi.getUserById(this.$store.getters.userId).then(resp => resp.data)
      Object.keys(this.form).forEach(item => {
        if (item in userInfo) {
          this.form[item] = userInfo[item]
        } else {
          this.form[item] = ''
        }
      })
    },
    async saveHandler() {
      const user = {}
      user.userId = this.$store.getters.userId
      user.englishName = this.form.englishName
      user.phone = this.form.phone
      user.cell = this.form.cell
      user.fax = this.form.fax
      user.qq = this.form.qq
      const loading = getLoading()
      userApi.updatePersonalInfo(user).then(resp => {
        this.$confirm(this.$t('Tool.SaveSucceed'))
        this.isEdit = false
        this.refreshUserInfo()
      }).finally(() => loading.close())
    },
    async refreshUserInfo() {
      const userInfo = await getAuthUserInfo(getToken()).then(resp => resp.data)
      this.$store.dispatch('user/setUserInfo', userInfo)
    },
    changeWeChatAuth(data) {
      // 如果开启的是微信推送通知时
      this.weChatVisible = false
      this.updataAuthorizationData(data)
    },
    onSmtpPortInput(value) {
      this.emailSettings.smtpPort = value.replace(/[^0-9]/g, '') || 0
    },
    saveDataService() {
      const data = {
        open: this.dataServiceForm.open,
        ruleItem: (this.dataServiceForm.ruleItem && this.dataServiceForm.ruleItem.length >0) ? this.dataServiceForm.ruleItem.join(',') : '',
        notifyJobType: this.dataServiceForm.notifyJobType,
        email: this.dataServiceForm.email,
        weChat: this.dataServiceForm.weChat
      }
      userApi.saveUserWarning(data).then(
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
      )
      this.isEditDataService = false
    },
    cancelDataService() {
      this.getWarningRule()
      this.isEditDataService = false
    }
  }
}
</script>

<style lang="scss" scoped>
.box-card{
  max-width: 500px;
  border-radius: 8px;
  border-width: 2px;
  margin: 0 auto;
  &.el-card{
    box-shadow: none;
  }
  /deep/ .el-card__header{
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    padding: 0;
    span{
      margin-left: 20px;
      line-height: 14px;
      font-size: 13px;
      color: #313131;
    }
  }
  /deep/ .el-card__body{
    padding: 40px;
    .personal-form{
     .el-form-item{
        margin-bottom: 24px !important;
        .el-form-item__label{
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          color: #313131;
        }
        .el-input{
          color: #000;
          font-size: 14px;
          input{
            &:disabled{
              color: #999;
            }
          }
        }
      }
    }
  }
  .personal-footer{
    padding-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .el-button{
      width: 140px;
    }
  }
  .ql-container{
    height:75px;
  }
  .mask{
    position: absolute;
    width: 100%;
    height: 100%;
    background: #ccc;
    opacity: 0.2;
    z-index: 999;
  }
}
.authorization {
  /deep/ .el-card__body{
    padding: 15px;
  }
  .warm-prompt-item {
    /deep/ .el-form-item__label {
      color: #999 !important;
    }
  }
}
</style>
